import { useEffect, useState } from "react";

const TARGET = new Date("2028-07-14T20:00:00Z").getTime();

function pad(n) {
  return String(n).padStart(2, "0");
}

function calc() {
  const now = Date.now();
  const diff = Math.max(0, TARGET - now);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);
  return { days, hours, minutes, seconds };
}

export default function Countdown({ size = "large" }) {
  const [t, setT] = useState(calc());
  useEffect(() => {
    const id = setInterval(() => setT(calc()), 1000);
    return () => clearInterval(id);
  }, []);

  const items = [
    { label: "DAYS", value: t.days },
    { label: "HRS", value: pad(t.hours) },
    { label: "MIN", value: pad(t.minutes) },
    { label: "SEC", value: pad(t.seconds) },
  ];

  return (
    <div
      data-testid="countdown-timer"
      className="flex flex-wrap items-end justify-center gap-3 sm:gap-5 font-mono"
    >
      {items.map((it, i) => (
        <div key={it.label} className="flex items-end gap-3 sm:gap-5">
          <div
            data-testid={`countdown-${it.label.toLowerCase()}`}
            className="relative flex flex-col items-center"
          >
            <div className="px-4 sm:px-6 py-3 sm:py-4 border border-white/15 bg-black/60 backdrop-blur-md min-w-[88px] sm:min-w-[110px] text-center">
              <div
                className={`${
                  size === "large"
                    ? "text-4xl sm:text-6xl"
                    : "text-3xl sm:text-4xl"
                } font-bold tracking-tight text-white glow-text leading-none`}
              >
                {it.value}
              </div>
            </div>
            <div className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.3em] text-[#00F0FF]">
              {it.label}
            </div>
          </div>
          {i < items.length - 1 && (
            <div className="text-3xl sm:text-5xl text-[#00F0FF] pb-7 sm:pb-9 select-none">
              :
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
